<template>
    <v-container class="fill-height" style="display: block; padding: 0px;" fluid>
        
        <criteria-regex-builder v-for="(groupingCriteria, index) in $props.groupingCriteriaList" :groupingCriteria="groupingCriteria" :index="index" @delete="deleteCriteria(index)" />
        <v-btn class="mr-2" @click="addCriteria" color="#c42111">Add Criteria</v-btn>
        <v-btn @click="showTestAlarms = !showTestAlarms" color="#c42111" v-if="$props.groupingCriteriaList.length">Test</v-btn>

        <div class="testing-area-outer" v-if="showTestAlarms">
            <div class="test-alarms-label">
                <span>Test Alarms</span>
            </div>
            <div class="testing-area mt-4">
                <template v-for="(testAlarm, index) in testAlarmsList">
                    <v-row dense>
                        <div class="test-alarm" :style="{backgroundColor: testAlarm.color}">
                            <v-col cols="12" sm="3">
                                <v-text-field class="testing-input-field" dense v-model="testAlarm.alarm_office" color="#c42111" label="Alarm Office" outlined />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field class="testing-input-field" dense v-model="testAlarm.alarm_location" color="#c42111" label="Alarm Location" outlined />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div>
                                    <v-text-field class="testing-input-field desc" dense v-model="testAlarm.alarm_description" color="#c42111" label="Alarm Description" outlined />
                                    <v-btn @click="deleteTestAlarm(index)" height="40" width="40" min-width="40" class="ml-2 delete-button" color="#c42111"><v-icon color="#ffffff">mdi-delete-forever</v-icon></v-btn>
                                </div>
                            </v-col>
                        </div>
                    </v-row>
                </template>
                <v-btn @click="addTestAlarm" color="#c42111" width="40" min-width="40"><v-icon>mdi-plus</v-icon></v-btn>
            </div>

        </div>
        
    </v-container>
</template>

<script>
import _ from 'lodash';
import CriteriaRegexBuilder from "@/components/AlarmCorrelations/CriteriaRegexBuilder";
export default {
    name: 'GroupingCriteria',
    props: ['groupingCriteriaList'],
    components: {
        CriteriaRegexBuilder
    },
    data: () => ({
        testString: null,
        showTestAlarms: false,
        testAlarmsList: [{alarm_office: "", alarm_location: "", alarm_description: "", rValues: [], color: ""}],
        colors: [
            'rgba(128,216,255,0.25)',
            'rgba(255,171,64,0.25)',
            'rgba(255,255,0,0.25)',
            'rgba(105,240,174,0.25)',
            'rgba(255,82,82,0.25)',
            'rgba(224,64,251,0.25)'
        ]

    }),

    computed: {
        testAlarmsListStr() {
            return JSON.stringify(this.testAlarmsList);
        }
    },

    methods: {
        addCriteria: function() {
            this.$props.groupingCriteriaList.push({
                input_field: "alarm_office",
                before_regex: "",
                inside_regex: ".+",
                after_regex: "",
                valid: true
            });
        },

        deleteCriteria: function(index) {
            this.$props.groupingCriteriaList.splice(index, 1);
            if(!this.$props.groupingCriteriaList.length) {
                this.showTestAlarms = false;
            }
            this.$emit('delete');
        },

        addTestAlarm: function() {
            this.testAlarmsList.push({
                alarm_office: "",
                alarm_location: "",
                alarm_description: "",
                rValues: [],
                color: ""
            });
        },

        deleteTestAlarm: function(index) {
            this.testAlarmsList.splice(index, 1);
        },

        runTest() {
            if(!this.showTestAlarms) {
                return;
            }
            for(let alarm of this.testAlarmsList) {
                alarm.rValues = [];
                for(let criteria of this.$props.groupingCriteriaList) {
                    // determine the test value(office || location || description)
                    let testValue = alarm[criteria.input_field];
                    // parse the value
                    let regex = new RegExp(`${criteria.before_regex}(?<common_value>${criteria.inside_regex})${criteria.after_regex}`, "gm");
                    let match = testValue.matchAll(regex).next();
                    if(match.value) {
                        alarm.rValues.push(match.value.groups.common_value);
                    }
                    else {
                        alarm.rValues.push("");
                    }
                }
            }

            // No we have computed the RegEx criteria values for each test alarm. We can "group" now.
            let alarmGroups = _.groupBy(this.testAlarmsList, a=> {
                return a.rValues;
            });

            for(let [idx,alarmGroupKey] of Object.keys(alarmGroups).entries()) {
                let alarms = alarmGroups[alarmGroupKey];
                if(!alarms) {
                    continue;
                }
                let color = this.colors[idx];
                for(let alarm of alarms) {
                    alarm.color = color;
                }
            }
        }

    },

    watch: {
        groupingCriteriaList: {
            handler(newVal, oldVal) {
                this.runTest();
            },
            deep: true
        },

        testAlarmsListStr: {
            handler(newVal, oldVal) {
                oldVal = JSON.parse(oldVal);
                newVal = JSON.parse(newVal);
                if(newVal.length != oldVal.length) {
                    this.runTest();
                    return;
                }
                for(let [idx, alarm] of newVal.entries()) {
                    if((newVal[idx].alarm_office != oldVal[idx].alarm_office) || (newVal[idx].alarm_location != oldVal[idx].alarm_location) || (newVal[idx].alarm_description != oldVal[idx].alarm_description)) {
                        this.runTest();
                        return;
                    }
                }
            },
        }
    },

    created() {
    },

    mounted() {

    }
};
</script>

<style scoped>

    .testing-area-outer {
        position: relative;
    }

    .testing-area {
        width: 100%;
        border: rgba(255,255,255,0.5) solid 1px;
        border-radius: 5px;
        display: block;
        padding: 20px 15px 15px 15px;
        overflow: auto;
    }

    .test-alarms-label {
        position: absolute;
        top: -12px;
        left: 40px;

        background-color: #424242;
        color: rgba(255,255,255,0.75);
        padding: 2px 6px;
        font-size: 14px;
    }

    .test-alarm {
        width: 100%;
        display: flex;
        height: 64px;
        margin-bottom: 10px;
        border-radius: 3px;
    }


    .testing-input-field {
        display: inline-block;
        width: 100%;
    }
    .testing-input-field.desc {
        width: calc(100% - 80px);
    }
    .delete-button {
        display: inline-block;
    }

</style>

<style>

    .criteria-input-field.regex.cvp .theme--dark.v-input--is-disabled .v-label, .theme--dark.v-input--is-disabled input, .theme--dark.v-input--is-disabled textarea {
        color: #ffffff;
        opacity: 0.8;
    }

</style>
